export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Campos do formulário Não."])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ID obrigatório ausente"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Você fez login com sucesso, continue as operações no caixa eletrônico"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Continuar transações em caixas eletrônicos"])}
}